<template>
  <section class="container mt-12">
    <div class="row">
      <div class="col-12 col-sm-10 offset-sm-1 tit-wrap">
        <div class="tit-style mb-2">
          <h1><strong>BRAND</strong> Film</h1>
        </div>
        <div class="text-center">
          <a href="https://www.youtube.com/channel/UCML_CB7lGSHomVqcSAWvLag" class="youtube-a" target="_blank">
            <img src="@/assets/images/common/ico_youtube.svg"  alt="유튜브" class="youtube-a--img">
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TitleArea',

};
</script>

<style lang='scss' scoped>
.mt-12{
  @media (max-width: $mobile-size) {
    margin-top: 14rem;
  }
}
</style>
